<template>
    <div>
        <loader v-if="loading"></loader>
        <b-table v-else striped hover class="mt-3" :items="memberships" :fields="fields">
            <template v-slot:cell(created_at)="data">
                {{ data.value | moment("DD/MM/YYYY HH:mm") }}
            </template>
            <template v-slot:cell(expired_at)="data">
                {{ data.value | moment("DD/MM/YYYY HH:mm") }}
            </template>
        </b-table>
        <b-alert :show="memberships.length === 0" variant="warning">Not found</b-alert>
    </div>
</template>

<script>
    import GetDriverMemberships from "../../../../store/actions/getDriverMemberships";
    import ContentLoader from "../../../../components/ContentLoader";
    import ShowError from "../../../../helpers/showError";

    export default {
        name: 'DriverMembershipComponent',
        data: () => ({
            loading: false,
            fields: [
                'price',
                'days',
                {
                    'key': 'created_at',
                    'label': 'Created',
                    'sortable': true
                },
                {
                    'key': 'expired_at',
                    'label': 'Expired',
                    'sortable': true
                }
            ],
            memberships: []
        }),
        components: {
            loader: ContentLoader,
        },
        created() {
            this.getActions();
        },
        methods: {
            async getActions() {
                try {
                    this.loading = true;
                    this.memberships = await GetDriverMemberships({
                        userId: this.$route.params.id,
                    });

                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>